/*eslint-disable multiline-ternary */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import downloadTypes from 'src/common/downloadTypes.json';
import { arrayBufferToBase64 } from 'src/Admin/utils/common';
import 'react-toastify/dist/ReactToastify.css';
import { axiosInstance } from '../../../../src/api/axios';
import Header from '../../components/common/Header/Header';
import CookiesService from '../../shared/CookiesService';
import APIEndpoints from '../../../Admin/api/APIEndpoints';
import HelpCenterSkeleton from './HelpCenterSkeleton';
import CustomClientError from '../../errorhandling/CustomClientError';
import ToastMessage from '../common/ToastMessage';
import './HelpCenter.scss';
import DocumentPdfImage from '../../img/documentpdf.svg';
import UserGuideImage from '../../img/userguide.svg';
import GlossaryImage from '../../img/glossary.svg';
import { useSelector } from 'react-redux';
import HttpHeader from 'src/Admin/shared/httpheader';

const HelpCenter = (props) => {
  const [loader, setLoader] = useState(false);
  const [adminUserGuide, setadminUserGuide] = useState({});
  const [adminGlossary, setadminGlossary] = useState({});
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);
  const { t } = useTranslation();
  const bearerToken = CookiesService.get('loginToken');
  const cName = HttpHeader.getCNAME();
  const { userData } = useSelector((state) => state.user);
  const { UserType, SuperUser } = userData;
  useEffect(() => {
    window.scrollTo(0, 0);
    setLoader(true);
    const getHelpCenterDocuments = async () => {
      return await axiosInstance.get(APIEndpoints.getAllHelpCenterDocuments(), {
        headers: { Authorization: bearerToken },
      });
    };
    (async () => {
      try {
        const helpDocuments = await getHelpCenterDocuments();
        const data = helpDocuments.data.Response.HelpPageList;
        console.log('Help-centre documents are:', data);
        data.map((doc) => {
          if (
            doc.key === 'UserGuide_Admin' &&
            UserType === 'Insurer' &&
            SuperUser === true
          ) {
            setadminUserGuide(doc);
          } else if (
            doc.key === 'UserGuide_Insurer' &&
            UserType === 'Insurer' &&
            SuperUser !== true
          ) {
            setadminUserGuide(doc);
          } else if (
            doc.key === 'UserGuide_Employer' &&
            UserType === 'Client'
          ) {
            setadminUserGuide(doc);
          } else if (doc.key === 'UserGuide_Broker' && UserType === 'Broker') {
            setadminUserGuide(doc);
          } else if (
            doc.key === 'UserGuide_Provider' &&
            UserType === 'Provider'
          ) {
            setadminUserGuide(doc);
          }
          if (doc.key === 'Glossary_Admin') {
            setadminGlossary(doc);
          }
        });
        setIsAPIFailed(false);
        setIsNotFound(false);
      } catch (err) {
        if (err.toString().includes('404')) {
          setIsNotFound(true);
        }
        setIsAPIFailed(true);
        console.log(err);
      } finally {
        setLoader(false);
      }
    })();
  }, []);

  const downloadFile = async (oid, fileName) => {
    try {
      //setLoader(true);

      const documentData = await axiosInstance.get(
        `${APIEndpoints.getDocument() + oid}`,
        { responseType: 'arraybuffer' },
      );

      const contentType = documentData.headers['content-type'];
      const extensionArr = downloadTypes.filter(
        (d) => contentType?.toLowerCase() === d.contentType,
      );

      let extension = '.pdf';
      fileName = fileName ? fileName : 'download';

      if (extensionArr?.length) extension = extensionArr[0].extension;

      const link = document.createElement('a');
      const actualData = arrayBufferToBase64(documentData.data);

      link.style.visibility = 'hidden';
      link.setAttribute('download', fileName + extension);
      link.setAttribute(
        'href',
        'data:' + contentType + ';base64,' + actualData,
      );

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);

      toast.success(
        <ToastMessage
          type="success"
          subTitle={`${t('file')}  ${t(
            'admin.toast_messages.download_successful',
          )}`}
        />,
      );
    } catch (error) {
      console.log(error);

      toast.error(
        <ToastMessage
          type="error"
          subTitle={`${t('admin.toast_messages.download_unsuccessful')}  ${t(
            'file',
          )}`}
        />,
      );
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <Container fluid className="help-center">
        <Header
          linkTo={'/admin/admin-dashboard'}
          header={t('admin.pages.helpcenter.module')}
        />

        {isAPIFailed && !loader ? (
          <div className="container-offset">
            {isNotFound ? (
              <CustomClientError ErrorHeading="No Help Center Documents found!" />
            ) : (
              <CustomClientError
                ErrorHeading="Something went wrong with request!"
                ErrorMessage="Please try again."
              />
            )}
          </div>
        ) : (
          <>
            {loader ? (
              <HelpCenterSkeleton />
            ) : (
              <Row className="health-card mt-3">
                <Col sm={2} md={12} lg={3} xs={12}>
                  <Card className="help-card">
                    <div className="help-card-content">
                      <div>
                        <img
                          className="help-card-logo"
                          src={UserGuideImage}
                          alt="logo"
                        />
                      </div>
                      <div className="help-card-name">
                        {adminUserGuide?.document_title || ''}
                      </div>
                      <div className="help-card-desc">
                        {adminUserGuide.keydesc || ''}
                      </div>
                      <div className="pl-3">
                        <img src={DocumentPdfImage} alt="logo" />
                        <a
                          className="download_document pl-2"
                          onClick={(e) =>
                            downloadFile(
                              adminUserGuide.value,
                              'UserGuide-' + UserType,
                              e,
                            )
                          }
                        >
                          {t('admin.pages.helpcenter.download_guide')}
                        </a>
                      </div>
                    </div>
                  </Card>
                </Col>
                )
                <Col sm={2} md={12} lg={3} xs={12}>
                  <Card className="help-card">
                    <div className="help-card-content">
                      <div>
                        <img
                          className="help-card-logo"
                          src={GlossaryImage}
                          alt="logo"
                        />
                      </div>
                      <div className="help-card-name">
                        {adminGlossary?.document_title || ''}
                      </div>
                      <div className="help-card-desc">
                        {adminGlossary.keydesc || ''}
                      </div>
                      <div className="pl-3">
                        <img src={DocumentPdfImage} alt="logo" />
                        <a
                          className="download_document pl-2"
                          onClick={(e) =>
                            downloadFile(adminGlossary.value, 'Glossary', e)
                          }
                        >
                          {t('admin.pages.helpcenter.download_glossary')}
                        </a>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col sm={8} md={12} lg={6} xs={12}></Col>
              </Row>
            )}
          </>
        )}
      </Container>
      <ToastContainer
        position="top-center"
        className="toastcontainer"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};
export default HelpCenter;
